import { IonGrid, IonCol, IonRow, IonChip, IonIcon, IonRefresherContent, IonRefresher, IonSearchbar, useIonViewWillEnter, useIonRouter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { heart, people } from 'ionicons/icons';
import React, { useState, useRef, useEffect }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import { Virtuoso } from 'react-virtuoso';

import { showAlert } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { Device } from '@capacitor/device';
import { Browser } from '@capacitor/browser';
import NServer, { UIElement, handleRouteError } from "../components/NServer";
import { ContentInfo, CreateContentInfo, FilterUniqueContent, ReponsiveContentResize, ReponsiveContentItemResize } from "../data/item";
import ContentWrapper from "../components/ContentWrapper";
import { LANGUAGE, GetStr } from "../language/Language";
import NoMoreContent from "../components/NoMoreContent";

import '../pages/Main.css'; 

var index = 0;
const total = 4;
var tokens = 0;
var noMoreLoadData = false;
var userName = 'User';
var userAvatar = "/assets/img/avt.jpg";
var ownUser = true;
var relationship = -1;
var followers = 0;
var loading = false;
var bm = 0;

const MePage : React.FC = () => {

    const [searchText, setSearchText] = useState('');
    const [totalLikes, setTotalLikes] = useState(0);
    const [contents, setContents] = useState<ContentInfo[]>([]);
    const [streams, setStreams] = useState<ContentInfo[]>([]);
    const [canRefresh, setCanRefresh] = useState(true);
    const [endOfContent, setEndOfContent] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        // refresh
        if (index == 0)
            doRefresh(null);

        // load again in case first time is not loaded
        setTimeout( () => {
            let e = document.getElementById('nc-content');
            if (e == null && !loading)
                doRefresh(null);
        }, 1000);
    });

    // when search text is changed
    useEffect(() => {
        // filter here
        let query = searchText.toLowerCase();
        console.log("Search-> " + query);
        if (query == "")
        {
            noMoreLoadData = false;
            setContents(getDefContents().concat(streams));
        }
        else
        {
            noMoreLoadData = true;

            setContents(streams.filter(d => 
                (d.desc.toLowerCase().indexOf(query) > -1) ||
                (d.title.toLowerCase().indexOf(query) > -1)));
        }

    }, [searchText]);

    const loadMoreData = async () => {
        if (noMoreLoadData || loading)
            return;

        await getData();
    }

    const getData = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            s: index,
            e: total,
            user: v.account.id
        }

        loading = true;

        var server = new NServer();
        await server.getList("nc_me_stream", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            const d = server.data;

            if (d != null)
            {
                userName = d.name;
                userAvatar = d.avatar;
                bm = d.bm;
                relationship = d.relationship;
                followers = d.followers;
                tokens = d.tokens;
                setTotalLikes(tokens);

                var dataStream = null;
                if (server.data.stream != null)
                {
                    if (index == 0)
                        dataStream = server.data.stream;
                    else
                        dataStream = streams.concat(server.data.stream);

                    // filter
                    dataStream = FilterUniqueContent(dataStream);
                    // responsive resize
                    dataStream = ReponsiveContentResize("me-con-view", dataStream);

                    setStreams(dataStream);
                }
                
                // if we reach end of data
                noMoreLoadData = d.nomore == "yes";
                index = d.index;

                let contentStream = getDefContents().concat(dataStream);
                
                setContents(contentStream);

                setEndOfContent(noMoreLoadData);
            }
        }

        loading = false;
    }

    // get the default content type array
    const getDefContents = () : ContentInfo[] => {
        
        let userPanel = CreateContentInfo(0, "user", userName, userAvatar);
        userPanel.likes = followers;
        userPanel.user_bm = bm;

        let threads : ContentInfo[] = [
            userPanel
        ];

        if (ownUser)
        {
            let mePanel = CreateContentInfo(0, "me", userName, userAvatar);
            mePanel.likes = followers;
            mePanel.user_bm = bm;

            threads = [
                mePanel,
                CreateContentInfo(1, "addmy", "", userAvatar)
            ];
        }

        return threads;
    }

    // just update specific content
    const getContentData = async (index: number, id : number) => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: id
        }

        var server = new NServer();
        await server.getList("nc_content", state);
        if (server.success)
        {
            if (server.data.tokens != null)
            {
                tokens = server.data.tokens;
                setTotalLikes(tokens);
            }

            let contentData : ContentInfo = server.data.content;
            contentData = ReponsiveContentItemResize("me-con-view", contentData);

            let defStream = getDefContents();
            streams[index-defStream.length] = contentData;
            setContents(defStream.concat(streams));
        }
    }

    // update a content
    const onUpdateContent = (index : number, content : ContentInfo, local : boolean) => {
        if (local)
        {
            // local update
            let defStream = getDefContents();
            streams[index-defStream.length] = content;
            setContents(defStream.concat(streams));
        }
        else
            getContentData(index, content.id);
    }

    const doSearch = async (term : string) => {
        setSearchText(term);
    }

    // refresh event
    const doRefresh = async (ev : any) => {
        // reset data
        userName = '';
        userAvatar = "/assets/img/avt.jpg";
        noMoreLoadData = false;
        bm = 0;
        index = 0;
        followers = 0;
        ownUser = true;
        loading = false;

        await getData();

        if (ev != null)
            ev.detail.complete();
    };

    // scroll event
    const onScrollTop = (val : boolean) => {
        setCanRefresh(val);
    }

    // click on love icon
    const onLike = () => {
        router.push("/token/wallet", "forward", "push");
    }

    return (
        <IonPage>
            <IonToolbar>
                <IonSearchbar className="search-bubble" placeholder={ GetStr(LANGUAGE.TXT_SEARCH) } value={searchText} onIonChange={e => doSearch(e.detail.value!)}></IonSearchbar>
            </IonToolbar>
            <IonContent fullscreen scrollY={false}>
                <IonRefresher className="refresher" slot="fixed" disabled={!canRefresh} onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonGrid className="ion-no-padding full-screen">
                    <IonRow className="full-screen">
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="5" size-sm="10" size="12">
                            <Virtuoso id="me-con-view" className="main-content ion-content-scroll-host"
                                defaultItemHeight={350}
                                atTopStateChange={onScrollTop}
                                data={contents}
                                totalCount={contents.length}
                                endReached={loadMoreData}
                                components={{
                                    Footer: () => {
                                        return (
                                            <NoMoreContent nomore={endOfContent} />
                                        )
                                    },
                                }}
                                itemContent={(index, content) => 
                                    <ContentWrapper key={content.id} content={content} index={index} onUpdate={onUpdateContent} view="def" autoplay={false} />
                                }
                            >
                            </Virtuoso>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default MePage;